import '@/utils/setup'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createPersistedStatePlugin } from 'pinia-plugin-persistedstate-2'

/**
 * ! plugins must be imported before router and store
 * - 1⃣ plugins contains vendor's css and also exposing lodash globally
 * - 2⃣ we also have global styles
 * - 3⃣ the router imports component styles
 * - we want import order to be [vendor, global, component]
 *   so we can easily override vendor styles
 */
import vuetify from '@/utils/plugins/vuetify'
import { installPlugins } from '@/utils/plugins' /* 1⃣ */
import '@/assets/scss/index.scss' /* 2⃣ */
import '@fontsource-variable/roboto/wght.css'
import '@fontsource-variable/roboto/wght-italic.css'
import '@fontsource-variable/roboto-mono/wght.css'
import '@fontsource/roboto-condensed/400.css'
import '@fontsource/roboto-condensed/700.css'
import router from '@/router' /* 3⃣ */
import i18n from '@/utils/plugins/i18n'
import CyApp from '@/CyApp.vue'
import { installStoreExtensions, migrateVuexPersistence } from '@/utils/plugins/pinia'
import { registerIconSets } from '@/utils/plugins/iconify'
import { appMode } from '@/utils/config/mode'
import { createWarnHandler } from '@/utils/warning'

migrateVuexPersistence()

const app = createApp(CyApp)

// Set specific Vue configurations
app.config.performance = !appMode.isProduction
app.config.productionTip = false
app.config.devtools = appMode.isDev || appMode.isStaging || appMode.isBeta

app.config.warnHandler = createWarnHandler((msg) => {
  return msg.startsWith('Computed property') || msg.includes('Avoid app logic that relies on enumerating keys')
})

const pinia = createPinia()
pinia.use(createPersistedStatePlugin({ persist: false }))
installStoreExtensions({ pinia, router })

// Install pinia before the cycloid plugins so stores created during their install()
// also receive the store extensions.
app.use(pinia)

installPlugins(app)

app.use(vuetify)
app.use(router)
app.use(i18n)

registerIconSets()

app.mount('#app')
